module.exports = __webpack_public_path__ + "img/es-mb-s6.d2791774.png";